/** Merchant-owned language for catalog questions and saved answers. */
export const storeKnowledgeCopy = {
    questionReason: 'Your answer helps us check for purchases after a sample order.',
    freeReason: 'This item appeared in orders at no charge.',
    catalogReason: 'Its catalog details suggest it may be a sample.',
    targetReason: 'This tells us which product to look for in later orders.',
    quickHeading: 'Quick question',
    quickSaved: 'Thanks, saved.',
    noQuestions: 'No questions for now.',
    chooseItem: 'Choose another item',
    sampleQuestion: 'Is this a sample?',
    yes: 'Yes',
    useProduct: 'This product',
    no: 'No',
    shortNotSure: 'Not sure',
    back: 'Back',
    shortTargetQuestion: 'Which product does it promote?',
    suggestedTargetQuestion: 'Which product does it promote?',
    chooseProduct: 'Choose a product',
    chooseAnother: 'Choose another',
    anotherUse: 'Record another use of this item',
    manualItem: 'Tell us how you use this item.',
    reload: 'Reload saved answer',
    heading: 'Help us understand your products',
    intro: 'Tell us how you use an item, so future insights use the right meaning.',
    suggested: 'Suggested items',
    browse: 'Browse all items',
    search: 'Find an item',
    searchAction: 'Search',
    more: 'Show more',
    noItems: 'No items found. Browse all items to choose one yourself.',
    loading: 'Loading items and answers…',
    failed: 'We could not load your saved answers. Try again.',
    retry: 'Try again',
    clue: (n) => `${n.toLocaleString()} orders include this item at no charge. How do you use it?`,
    nameClue: 'Its name, type or tags may describe a sample. Please confirm how you use it.',
    product: 'Whole product',
    variant: 'Variant',
    unnamed: 'Untitled item',
    savedHeading: 'Your saved answers',
    noSaved: 'No answers saved yet.',
    open: 'View or correct',
    close: 'Close item',
    roleQuestion: 'How do you use this item?',
    chooseRole: 'Choose its use',
    roles: {
        sample: 'Sample',
        gift: 'Gift',
        packaging: 'Packaging',
        replacement: 'Replacement',
        retail: 'Retail product',
        other: 'Other',
    },
    scope: 'When does this answer apply?',
    scopes: {
        all_observed: 'All observed uses of this item',
        order_interval: 'Orders in a date range',
        unresolved: 'A promotion or other specific context',
    },
    start: 'From date (included, UTC)',
    end: 'To date (not included, UTC)',
    context: 'Describe the promotion or context',
    contextHelp: 'We will save this context, but need to define which orders it covers before using it in calculations.',
    targetQuestion: 'Which retail products is this sample intended to encourage people to buy?',
    targetStates: { selected: 'Choose retail products', none: 'No specific retail product', unknown: 'I’m not sure yet' },
    targetHelp: 'This records your intended purchase, not whether shoppers see the items as the same product.',
    targetSearch: 'Find a retail product',
    addTarget: 'Add',
    removeTarget: 'Remove',
    note: 'Additional details',
    save: 'Save answer',
    correct: 'Save correction',
    skip: 'Skip for now',
    notSure: 'I’m not sure',
    withdraw: 'Withdraw answer',
    saved: 'Answer saved. You can reopen and correct it below.',
    saveFailed: 'We could not save this answer. Review the details and try again.',
    invalid: 'Choose a use and complete the relevant fields before saving.',
    history: 'Answer history',
    older: 'Show older answers',
    current: 'Current answer',
    states: { confirmed: 'Confirmed by your store', unresolved: 'Needs clarification', withdrawn: 'Withdrawn' },
    responses: {
        not_sample: 'Not a sample',
        skip: 'Skipped for now',
        not_sure: 'Not sure yet',
        withdraw: 'Answer withdrawn',
    },
    unknownTargets: 'Retail products not yet confirmed',
    noneTargets: 'No specific retail product',
    attribution: (actor, time) => `Answered by ${actor} · ${new Date(time).toLocaleString()}`,
    version: (n) => `Answer ${n}`,
    selected: (n) => `${n} retail products selected`,
};
//# sourceMappingURL=store-knowledge.js.map